import { Component, ViewChild, ElementRef } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';
import domtoimage from 'dom-to-image';
import { LoginProvider } from '../../providers/login/login';
import { SocialSharing } from '@ionic-native/social-sharing';
import { TranslateService } from '@ngx-translate/core';

@IonicPage()
@Component({
  selector: 'page-share-pass',
  templateUrl: 'share-pass.html',
})
export class SharePassPage {
  @ViewChild('Html2Image') myDiv: ElementRef;

  colors = {
    cab: '#ed553b',
    delivery: '#20639b',
    guest: '#173f5f'
  }

  pass;
  screenshot;
  userDetails;
  msg;
  societySettings = {};
  societyAdd;

  constructor(public navCtrl: NavController, 
    public navParams: NavParams,
    private translate: TranslateService,
    private login: LoginProvider,
    private socialSharing: SocialSharing,
    private loadingCtrl: LoadingController
    ) {
      this.pass = this.navParams.get("passDetails");
      this.userDetails = this.navParams.get("userDetails");
      this.msg = (this.navParams.get("msg"))?this.navParams.get("msg"):"iSocietyManager generated pass";

      this.login.getSocietySettings().then(val => {
        console.log(val);
        this.societySettings = val;
        this.societyAdd = this.societySettings['society_data'].Address;
      });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SharePassPage');
    
    let loader = this.loadingCtrl.create({});

    loader.present().then(() => {
      domtoimage.toPng(this.myDiv.nativeElement)
      .then((dataUrl) => {
        loader.dismiss();
        this.socialSharing.share(this.msg, "Pass for your Complex", dataUrl);
      })
      .catch(function (error) {
        loader.dismiss();
        console.error('oops, something went wrong!', error);
      });
    });

  }

}



// WEBPACK FOOTER //
// ./src/pages/share-pass/share-pass.ts